import { ComponentClassNames } from '../../util/classNames';
import { Depth, getDepthBoxShadow } from '../../util/styles/depth';
import { getGutterValue } from '../../util/styles/gutters';
import { ITheme, memoizeFunction, mergeStyleSets } from '../../util/styling';
import { ITooltipHostStyles } from '../Tooltip';

export const panelExpandedWidth = 260;
export const panelCollapsedWidth = 64;

export const tooltipStyle: Partial<ITooltipHostStyles> = {
  root: { display: 'inline-block' },
};

type CollapsibleClassNames = ComponentClassNames<
  'collapsiblePanel' | 'container' | 'content' | 'contentInner' | 'footer'
>;
export const getClassNames = memoizeFunction((isCollapsed: boolean, theme: ITheme): CollapsibleClassNames => {
  const contentHorizontalPadding = isCollapsed ? 15 : getGutterValue(3);

  return mergeStyleSets({
    collapsiblePanel: {
      height: '100%',
      overflowY: 'hidden',
      width: isCollapsed ? panelCollapsedWidth : panelExpandedWidth,
      background: theme.isInverted ? theme.palette.neutralLighter : theme.palette.white,
      boxShadow: getDepthBoxShadow(Depth.depth8),
    },
    container: {
      overflowY: 'hidden',
    },
    content: {
      overflowY: 'hidden',
    },
    contentInner: {
      paddingLeft: contentHorizontalPadding,
      paddingRight: contentHorizontalPadding,
    },
    footer: {
      borderTop: `1px solid ${theme.semanticColors.bodyDivider}`,
      paddingBottom: getGutterValue(2),
      textAlign: isCollapsed ? 'center' : undefined,
    },
  });
});
